module.exports = __webpack_public_path__ + "img/ellipse-inside-blur-green.a480f264.svg";